import client from '../client'

export async function cancelDirectOfferByBuyer({ directOfferId }) {
  return client(
    `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/CancelDirectOfferByBuyer`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ directOfferId }),
    },
  )
}
